import { httpClient } from '../httpClient';
import { IVideoClip, ImageAnalyzeMode } from '@packages/global';

export class PromptHelperApi {
  /**
   * 生成视频提示词
   */
  async generateVideoPrompt(videoClip: IVideoClip, isStoryboardGuide?: boolean): Promise<{ prompt: string }> {
    return httpClient.post('/user/promptHelper/generate/video', { videoClip, isStoryboardGuide });
  }

  /**
   * 生成图片提示词
   */
  async generateImagePrompt(videoClip: IVideoClip, frameType: 'start' | 'end' | 'storyboard', currentParams: any): Promise<{ prompt: string }> {
    return httpClient.post('/user/promptHelper/generate/image', { videoClip, frameType, currentParams });
  }

  /**
   * 分析图片生成提示词
   * @param imageUrl 图片URL
   * @param mode 分析模式：default(默认) | character(角色) | prop(道具) | scene(场景)
   */
  async analyzeImagePrompt(imageUrl: string, mode?: ImageAnalyzeMode): Promise<{ prompt: string }> {
    return httpClient.post('/user/promptHelper/analyze/image', { imageUrl, mode });
  }
}

export const promptHelperApi = new PromptHelperApi();
